export const sortDirection = {
  asc: "ASC",
  desc: "DESC",
} as const;
